export const ALERTS_TABLE_DENSITY_STORAGE_KEY = "alertsTableDensity";
export const ALERTS_DENSITY_AUTO_WORKSPACE_WIDTH = 1150;
export const ALERTS_NAV_AUTO_COLLAPSE_WINDOW_WIDTH = 1400;
export const ALERTS_PAGE_MIN_WIDTH_PX = 850;

export const getAlertsPageWidth = (windowWidth: number) =>
  Math.max(windowWidth, ALERTS_PAGE_MIN_WIDTH_PX);

export type AlertsTableDensity = "detailed" | "condensed";

export const readPinnedAlertsTableDensity = (): AlertsTableDensity | null => {
  try {
    const value = localStorage.getItem(ALERTS_TABLE_DENSITY_STORAGE_KEY);
    if (value === "detailed" || value === "condensed") {
      return value;
    }
  } catch {
    // Ignore quota / private-mode failures and fall back to auto.
  }
  return null;
};

export const writePinnedAlertsTableDensity = (mode: AlertsTableDensity) => {
  localStorage.setItem(ALERTS_TABLE_DENSITY_STORAGE_KEY, mode);
};

export const resolveAlertsTableDensity = ({
  workspaceWidth,
  pinnedMode,
}: {
  workspaceWidth: number;
  pinnedMode: AlertsTableDensity | null;
}): AlertsTableDensity => {
  if (pinnedMode === "detailed" || pinnedMode === "condensed") {
    return pinnedMode;
  }
  return workspaceWidth < ALERTS_DENSITY_AUTO_WORKSPACE_WIDTH
    ? "condensed"
    : "detailed";
};

export const getAlertsGridTemplateColumns = (density: AlertsTableDensity) =>
  density === "condensed" ? "7fr 13fr" : "11fr 13fr";

export const shouldShowAlertsApplyFiltersPrompt = ({
  pageLoading,
  filtersApplied,
}: {
  pageLoading: boolean;
  filtersApplied: boolean;
}) => !pageLoading && !filtersApplied;

export const shouldShowAlertDetailPane = ({
  seeMoreURL,
  alertsToDisplay,
  selectedRow,
}: {
  seeMoreURL?: string | null;
  alertsToDisplay: boolean;
  selectedRow: unknown;
}) => Boolean(seeMoreURL && alertsToDisplay && selectedRow);
